<template>
  <div id="jumpBreadcrumb">
    <v-container
      v-show="breadcrumbs.length"
      class="d-print-none hidden-sm-and-down"
    >
      <v-col class="pb-1 px-0">
        <nav class="breadcrumb" role="list">
          <template v-for="(crumb, i) in breadcrumbs">
            <router-link
              v-if="crumb.type == 'link'"
              :key="i"
              custom
              :to="crumb.linkProp"
              class="breadcrumb-item"
              role="listitem"
            >
              {{ crumb.name }}
            </router-link>
            <span
              v-else-if="crumb.type == 'current'"
              :key="i"
              aria-current="page"
              class="muted--text breadcrumb-item"
              role="listitem"
            >
              {{ crumb.name }}
            </span>
            <span
              v-else-if="crumb.type == 'divider'"
              :key="i"
              class="mx-2"
              role="listitem"
              >/</span
            >
          </template>
        </nav>
      </v-col>
    </v-container>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { truncate } from "lodash-es";
import FipaListener from "@/utils/listenerUtility";

export default defineComponent({
  name: "AppBreadcrumbs",
  data() {
    return {
      dynamicPages: {}
    };
  },
  computed: {
    breadcrumbs() {
      const routesFiltered = this.$route.matched.filter(({ meta }) => {
        // Remove items that do not have meta, breadcrumb or has ignoreThis
        if (!meta || meta.ignoreThis == true) return false;
        return meta.breadcrumb || meta.breadcrumbI18n;
      });
      const routesLength = routesFiltered.length - 1;
      const breadcrumbs = routesFiltered.reduce((arr, route, index) => {
        const { meta, path } = route;
        let name, linkProp;

        const metaBreadcrumb = meta?.breadcrumb ?? null;
        const dynamicPageData =
          this.dynamicPages[metaBreadcrumb?.breadcrumbName] ?? null;
        if (metaBreadcrumb?.breadcrumbName) {
          name = dynamicPageData?.name ?? "...";
        } else if (meta.breadcrumbI18n) {
          name = this.$t(meta.breadcrumbI18n, route.name);
        } else if (meta.breadcrumb) {
          name = this.$t(
            "navigation:breadcrumbs." + route.name + ".title",
            meta.breadcrumb
          );
        } else name = route.name;

        if (name.length > 55) {
          name = truncate(name, { length: 55 });
        }

        linkProp = {
          [route.name ? "name" : "path"]: route.name || path,
          params: metaBreadcrumb?.pageParam ?? ""
        };

        arr.push({
          path: path,
          type: routesLength == index ? "current" : "link",
          name,
          linkProp: routesLength == index ? null : linkProp
        });

        if (routesLength != index) {
          arr.push({
            type: "divider"
          });
        }

        return arr;
      }, []);

      return breadcrumbs.length > 1 ? breadcrumbs : [];
    }
  },
  beforeMount() {
    FipaListener.on("breadcrumbPageName", this.emitBreadcrumb);
  },
  beforeDestroy() {
    FipaListener.off("breadcrumbPageName", this.emitBreadcrumb);
  },
  methods: {
    emitBreadcrumb({ detail }) {
      this.$set(this.dynamicPages, detail.breadcrumbName, {
        name: detail.name,
        pageParam: detail.id
      });
    }
  }
});
</script>
<style>
.breadcrumb {
  display: inline-flex;
  list-style: none;
  font-size: 15px;
  padding: 0;
}
.breadcrumb a[href].breadcrumb-item,
.breadcrumb span {
  color: #9b9b9b !important;
}
.breadcrumb a[href]:hover.breadcrumb-item {
  color: #3d54a2 !important;
}
span.breadcrumb-item {
  font-weight: 600 !important;
}
</style>
